import moment from "moment";
import { forwardRef } from "react";
import DatePicker from "react-datepicker";
import { CalenderIcon } from "assets/svgs";
import { useAppSelector } from "store/hooks";
import { userSettingState } from "store/selectors";
import "react-datepicker/dist/react-datepicker.css";
import styles from "./styles.module.css";

function getDate(date: any) {
  return date ? new Date(date) : null;
}

export function CustomDateRange({ onChange, value = [], maxDate = null }: any) {
  const { isDarkMode } = useAppSelector(userSettingState);
  const [startDate, endDate] = value;

  const maxDateProp = maxDate ? { maxDate } : {};

  return (
    <div
      className={`${styles.customDateInput} ${
        isDarkMode ? "dark-mode-date-picker" : ""
      }`}
    >
      <DatePicker
        selectsRange={true}
        startDate={getDate(startDate)}
        endDate={getDate(endDate)}
        onChange={(date: any) => {
          const convertedDate = date.map((item: any) => {
            return item ? moment(item).format("YYYY-MM-DD") : null;
          });

          onChange(convertedDate);
        }}
        className={isDarkMode ? "dark-mode-date-picker" : ""}
        customInput={<CustomDate />}
        dateFormat="dd/MM/yyy" // Customize date format if needed
        {...maxDateProp}
      />
    </div>
  );
}

const CustomDate = forwardRef(({ value, onClick }: any, ref: any) => {
  const { isDarkMode } = useAppSelector(userSettingState);
  return (
    <button
      type="button"
      className={`${styles.dateSelectBtn} ${isDarkMode ? styles.darkMode : ""}`}
      onClick={onClick}
      ref={ref}
    >
      <span className={value ? styles.value : styles.placeholder}>
        {value || "Select Date Range"}
      </span>
      <CalenderIcon />
    </button>
  );
});
